import { InjectionToken } from '@angular/core';
import { IEnvironment } from './model';

export const MY_ENV = new InjectionToken<IEnvironment>('My Environment');